import React from "react";
import ReactApexChart from "react-apexcharts";
import { fCurrency, fNumber } from '../../../../utils/formatNumber';

const ApexChart = ({series,labels,colors}) => {

    const options = {
        chart: {
            height: 330,
            type: "radialBar",
        },
        plotOptions: {
            radialBar: {
                startAngle: -160,
                endAngle: 160,
                dataLabels: {
                    name: {
                        fontSize: '22px',
                    },
                    value: {
                        fontSize: '16px',
                    },
                }
            },
        },
        stroke: {
            lineCap: 'round',
        },
        labels:labels,
        colors: colors,
    };
         

  

  return (
   
     <div id="chart" >
				<ReactApexChart
				  options={options}
				  series={series}
				  type="radialBar"
				  height={330}
				/>
			</div>
   
  );
};
export default ApexChart;
